import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { LocaleRouteWrapper } from './router/LocaleRouteWrapper';
import { GlobalErrorBoundary } from '@components/GlobalErrorBoundary';
import OrderLoadingPage from '@shared/pages/OrderLoadingPage';

const OrderRoutes = lazy(() => import('./router/OrderRoutes'));
const NotFoundPage = lazy(() => import('@shared/pages/NotFoundPage'));

const OrderRedirect: React.FC = () => {
  const { orderId, '*': rest } = useParams();
  const path = rest ? `/ru/order/${orderId}/${rest}` : `/ru/order/${orderId}`;
  return <Navigate to={path} replace />;
};

const App: React.FC = () => {
  return (
    <GlobalErrorBoundary>
      <Suspense fallback={<OrderLoadingPage />}>
        <Routes>
          <Route path='/' element={<Navigate to='/ru' replace />} />
          <Route path='/order/:orderId/*' element={<OrderRedirect />} />

          <Route path='/:locale/*' element={<LocaleRouteWrapper />}>
            <Route path='order/:orderId/*' element={<OrderRoutes />} />
            <Route path='*' element={<NotFoundPage />} />
          </Route>

          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </GlobalErrorBoundary>
  );
};

export default App;
